import {
  type ButtonHTMLAttributes,
  type CSSProperties,
  forwardRef,
} from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

const baseStyle: CSSProperties = {
  minHeight: 'var(--tap)',
  minWidth: 'var(--tap)',
  padding: '10px 18px',
  borderRadius: '999px',
  border: '1px solid transparent',
  fontWeight: 600,
  fontSize: 15,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  transition: 'transform 80ms ease, background 120ms ease',
};

const variants: Record<ButtonVariant, CSSProperties> = {
  primary: { background: 'var(--accent)', color: '#0b0b0f' },
  secondary: {
    background: 'rgba(255,255,255,0.08)',
    color: 'var(--text)',
    border: '1px solid rgba(255,255,255,0.16)',
  },
  ghost: { background: 'transparent', color: 'var(--text)' },
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'secondary', style, disabled, ...rest }, ref) => {
    return (
      <button
        ref={ref}
        disabled={disabled}
        style={{
          ...baseStyle,
          ...variants[variant],
          opacity: disabled ? 0.5 : 1,
          cursor: disabled ? 'not-allowed' : 'pointer',
          ...style,
        }}
        {...rest}
      />
    );
  },
);
Button.displayName = 'Button';
